import { useTranslation } from "react-i18next"
import { RadioGroup, RadioGroupItem, RadioGroupLabel } from "@/components/ui/radio-group"
import { MEDICATION_VERIFICATION_STATUSES } from "@/modules/patients/detail/medication/types/medication-verification-status"
import { VerifyMedicationStatus } from "@/types/__generated__/union-types"

type EmptyMedicationQuestionProps = {
  verificationStatus: VerifyMedicationStatus
  setVerificationStatus: (status: VerifyMedicationStatus) => void
}

export const EmptyMedicationQuestion = ({
  verificationStatus,
  setVerificationStatus,
}: EmptyMedicationQuestionProps) => {
  const { t } = useTranslation()

  return (
    <div className="grid gap-2 py-4">
      <label className="text-on-surface-subdued text-sm">
        {t("patient.healthInformation.medication.emptyQuestions")}
      </label>
      <RadioGroup
        className="flex flex-wrap"
        data-testid="empty-medication-question-radio-group"
        defaultValue={verificationStatus}
        onValueChange={setVerificationStatus}>
        {MEDICATION_VERIFICATION_STATUSES.map((option) => (
          <RadioGroupItem className="pr-1" value={option} key={option} data-testid={`${option}-radio-item`}>
            <RadioGroupLabel>{t(`patient.healthInformation.medication.options.${option}`)}</RadioGroupLabel>
          </RadioGroupItem>
        ))}
      </RadioGroup>
    </div>
  )
}
